export const FILTER_CACHE_PREFIX = 'FDH_MS:FILTER_CACHE'
export const FILTER_CACHE_VERSION = 'v1'

export const FILTER_CACHE_PAGE_KEYS = Object.freeze({
  WORK_ORDER_LIST: 'workOrderList',
  SATISFACTION_LIST: 'satisfactionList',
  BD_WORK_ORDER_LIST: 'bdWorkOrderList',
  BD_POOL_LIST: 'bdPoolList',
  DOCTOR_POOL_LIST: 'doctorPoolList',
  PATIENT_POOL_LIST: 'patientPoolList',
  PRE_MEDICAL_RECORD_LIST: 'preMedicalRecordList',
  CALL_LOG_LIST: 'callLogList',
  SMS_LOG_LIST: 'smsLogList',
  EXCELLENT_CASE_LIST: 'excellentCaseList',
  CHECKLIST_LIST: 'checklistList',
  PERFORMANCE_STATS: 'performanceStats',
  SALES_COMMISSION_STATS: 'salesCommissionStats',
  ALARM_REMINDER_LIST: 'alarmReminderList'
})
